
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import { useTranslation } from 'react-i18next';

const CookiesPolicy = () => {
  const { t } = useTranslation('cookies');

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title={t('meta.title')}
        description={t('meta.description')}
        url="/cookies"
      />
      <Navbar />
      <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl md:text-4xl font-bold text-frikopplad-navy mb-6">{t('title')}</h1>
        
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-frikopplad-navy mb-4">{t('introduction.title')}</h2>
          <p className="mb-4">{t('introduction.text1')}</p>
          <p>{t('introduction.text2')}</p>
        </section>
        
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-frikopplad-navy mb-4">{t('whatWeUse.title')}</h2>
          
          <div className="mb-6">
            <h3 className="text-xl font-medium text-frikopplad-navy mb-2">{t('whatWeUse.consent.title')}</h3>
            <p>{t('whatWeUse.consent.text')}</p>
          </div>
          
          <div className="mb-6">
            <h3 className="text-xl font-medium text-frikopplad-navy mb-2">{t('whatWeUse.preferences.title')}</h3>
            <p>{t('whatWeUse.preferences.text')}</p>
          </div>
          
          <div className="mb-6">
            <h3 className="text-xl font-medium text-frikopplad-navy mb-2">{t('whatWeUse.noCookies.title')}</h3>
            <p>{t('whatWeUse.noCookies.text')}</p>
          </div>
        </section>
        
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-frikopplad-navy mb-4">{t('control.title')}</h2>
          <p className="mb-4">{t('control.text1')}</p>
          <p>{t('control.text2')}</p>
        </section>
        
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-frikopplad-navy mb-4">{t('changes.title')}</h2>
          <p>{t('changes.text')}</p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CookiesPolicy;
